export default ["LECTURER", "RESEARCH_ASSISTANT", "ASSISTANT_PROFESSOR", "ASSOCIATE_PROFESSOR", "PROFESSOR"];
